import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { useState } from "react";
import { AddLogCallAPI } from "../../../../components/AddLogs";
import Step1 from "./components/Step1";
import Step2 from "./components/Step2";

const AddTuyaAccount = ({ setShowTuyaAddFormNew, setLoading, setSnackbarMsg, setSnackbarOpen, onSubmitLocal, propertyList }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [step, setStep] = useState(1);
    const [tuyaData, setTuyaData] = useState(null);

    const onSubmit = async (selectedDevices) => {
        setShowTuyaAddFormNew(false);
        setLoading(true);

        let data = { ...tuyaData, devices: selectedDevices };

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        axios.post(process.env.REACT_APP_DEVICE_API_URL + "v1/tuya-accounts", data, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            let rData = response.data.data;
            onSubmitLocal(rData);

            let logData = {
                'title': 'New IoT account has been added',
                'description': [
                    'Project name: ' + rData?.name,
                    'Apartment: ' + rData?.property_name + ' - ' + rData?.apt_name
                ]
            }
            AddLogCallAPI(logData, token);

        }).catch((error) => {
            setLoading(false);
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });
    }

    const onSubmit2 = async (tuyaData) => {
        setShowTuyaAddFormNew(false);
        setLoading(true);


        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        axios.post(process.env.REACT_APP_DEVICE_API_URL + "v1/tuya-accounts", tuyaData, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            let rData = response.data.data;
            onSubmitLocal(rData);

            let logData = {
                'title': 'New IoT account has been added',
                'description': [
                    'Project name: ' + rData?.name,
                    'Apartment: ' + rData?.property_name + ' - ' + rData?.apt_name
                ]
            }
            AddLogCallAPI(logData, token);

        }).catch((error) => {
            setLoading(false);
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });
    }

    return (<>
        {step === 1 && <Step1 propertyList={propertyList} onSubmitLocal={onSubmit2.bind(this)} setShowTuyaAddFormNew={setShowTuyaAddFormNew.bind(this)} tuyaData={tuyaData} setTuyaData={setTuyaData.bind(this)} setStep={setStep.bind(this)} setLoading={setLoading.bind(this)} />}

        {step === 2 && <Step2 onSubmitLocal={onSubmit.bind(this)} tuyaData={tuyaData} setStep={setStep.bind(this)} />}

    </>);
};

export default AddTuyaAccount;